import axios from './Instance/axiosInstance'; // Assuming you have a base instance

export type StockEntry = {
    unit: "piece" | "set" | "carton" | "meter" | "roll" | "box" | "other";
    qty: number;
    unitLength?: number;
    date?: string;
    attributes?: Record<string, any>;
};

// Result of the shared stock rule, recalculated by the server every time a
// sale / return / purchase touches the product. See utils/stockHelpers.ts.
export type ComputedStock = {
    unit: string;
    qty: number;
};

export type Product = {
    id?: string;
    code: string;
    name: string;
    category?: string;
    sku?: string;
    barcode?: string;
    buyPriceInDollar: number;
    buyPriceInDinar: number;
    sellPriceInDollar: number;
    sellPriceInDinar: number;
    currentStock: StockEntry[];
    computedStock?: ComputedStock[];
    stockCountedFrom?: string;
    stockRecalculatedAt?: string;
    attributes?: Record<string, any>;
};

export type ResetStockResponse = {
    message: string;
    countFrom: string;
    productsMatched: number;
    productsUpdated: number;
};

export const getProducts = () => axios.get<Product[]>('/products');
export const getProduct = (id: string) => axios.get<Product>(`/products/${id}`);
// Live stock per unit, e.g. { piece: 52 }, counted from the invoices on request
// by the same rule the reports use. Unlike `computedStock` on the product this
// is never a cache, so it cannot go stale.
export const getProductCurrentStock = (id: string) =>
    axios.get<Record<string, number>>(`/products/${id}/current-stock`);
export const createProduct = (data: Product) => axios.post<Product>('/products', data);
export const updateProduct = (id: string, data: Product) => axios.put<Product>(`/products/${id}`, data);
export const deleteProduct = (id: string) => axios.delete(`/products/${id}`);

// Bulk-resets the stock of every product to zero, using `date` as the new
// baseline day stock is counted from. Destructive — always confirm first.
export const resetAllStock = (date: string, unit?: StockEntry['unit']) =>
    axios.post<ResetStockResponse>('/products/reset-stock', unit ? { date, unit } : { date });
